// extracted by mini-css-extract-plugin
export default {"dayPicker":"DayPicker-module__dayPicker--QioRm","animatedBackground":"DayPicker-module__animatedBackground--_2lJG"};